module.exports = __webpack_public_path__ + "static/media/Artboard13.786fb696.png";